import { propertyDraftQueryKeys as e } from "./propertyDraftQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { propertyDraftsApi as r } from "@maat/api-main";
//#region src/propertyDrafts/useDeletePropertyDraftMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.deleteDraft(e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useDeletePropertyDraftMutation };
